/** @format */
import React, { useState, useEffect } from "react";
import { Select, message } from "antd";
import { connect } from "react-redux";
import { getCurrencyConversion, getCurrentFormat } from "../../store/actions";
import { currencySwitchEvent } from "../../utils/GTMDataLayer";

const { Option } = Select;
function CurrencyConverter(props) {
  const [baseCurrency, setBaseCurrency] = useState("USD");

  useEffect(() => {
    let buyerId = props.userProfile && props.userProfile.profileId ? props.userProfile.profileId : null;
    props.getCurrencyConversion(baseCurrency, buyerId, (result) => {
      let { error = false } = result;
      if(error) {
        message.error('Something went wrong. Please try again in sometime.', 5);
      }
    });
    let currencySelected = localStorage.getItem("CURRENCY_SELECTED") || "USD";
    props.getCurrentFormat(currencySelected);
  }, []);

  const changeConvertToCurrency = (value) => {
    currencySwitchEvent(baseCurrency,value)
    localStorage.setItem("CURRENCY_SELECTED", value);
    props.getCurrentFormat(value);
  };

  let { currencies = [], convertToCurrency = "USD" } = props.data;
  let { mobile = false } = props;

  let currencyChoice = [];
  let currencyOptions = [];

  if (currencies.length) {
    currencies = currencies.filter((currency) => {
      if (
        currency === "GBP" ||
        currency === "EUR" ||
        currency === "AUD" ||
        currency === "USD"
      ) {
        return true;
      }
    });
    currencyChoice = currencies.map((currency) => (
      <Option key={currency} value={currency}>
        {currency}
      </Option>
    ));
    currencyOptions = currencies.map((currency) => (
      <div
        key={currency}
        onClick={() => {
          changeConvertToCurrency(currency);
        }}
      >
        {currency}
      </div>
    ));
  }

  if (mobile) {
    return <div className="currency-conversion-block">{currencyOptions}</div>;
  } else {
    return (
      <div
        style={{ display: "inline-block", marginRight: "0px" }}
        className="currency-conversion-block"
      >
        <Select
          className="qa-dark-menu-theme currency-converter"
          dropdownClassName="qa-dark-menu-theme currency-converter crncy-dropdown"
          value={convertToCurrency}
          onChange={changeConvertToCurrency}
        >
          {currencyChoice}
        </Select>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state.currencyConverter,
    userProfile: state.userProfile.userProfile,
  };
};

export default connect(mapStateToProps, {
  getCurrencyConversion,
  getCurrentFormat,
})(CurrencyConverter);
